import { UiModuleTheme, ThemeType } from "./";

const lightTheme: UiModuleTheme = {
  type: ThemeType.LIGHT,
  bodyBackground: "rgba(245, 245, 245, 1)",
  successColor: "rgba(67, 181, 129, 1)",
  appBarBackground: "rgb(28, 28, 36, 1)",
  sideBarBackground: "rgba(28, 28, 36, 1)",
  skeletonBg: "rgba(195, 195, 195, 1)",
  material: {
    primary: "rgba(22, 181, 231, 1)",
    secondary: "rgba(250, 166, 26, 1)",
    error: "rgba(240, 71, 71, 1)",
    background: "rgba(255, 255, 255, 1)",
    surface: "rgba(255, 255, 255, 1)",
    onPrimary: "rgba(255, 255, 255, 1)",
    onSecondary: "rgba(255, 255, 255, 0.87)",
    onSurface: "rgba(0, 0, 0, 0.87)",
    onError: "rgba(255, 255, 255, 1)",
    textPrimaryOnBackground: "rgba(0, 0, 0, 0.87)",
    textSecondaryOnBackground: "rgba(0, 0, 0, 0.54)",
    textHintOnBackground: "rgba(0, 0, 0, 0.38)",
    textDisabledOnBackground: "rgba(0, 0, 0, 0.38)",
    textIconOnBackground: "rgba(0, 0, 0, 0.38)",
    textPrimaryOnLight: "rgba(0, 0, 0, 0.87)",
    textSecondaryOnLight: "rgba(0, 0, 0, 0.54)",
    textHintOnLight: "rgba(0, 0, 0, 0.38)",
    textDisabledOnLight: "rgba(191, 191, 191, 1)",
    textIconOnLight: "rgba(0, 0, 0, 0.38)",
    textPrimaryOnDark: "rgba(255, 255, 255, 1)",
    textSecondaryOnDark: "rgba(255, 255, 255, 0.7)",
    textHintOnDark: "rgba(255, 255, 255, 0.5)",
    textDisabledOnDark: "rgba(255, 255, 255, 0.5)",
    textIconOnDark: "rgba(255, 255, 255, 0.5)",
  },
};

export default lightTheme;
